import RequestCodeForm from '@features/games/profile/validate-phone/request-code-form/request-code-form';
export default RequestCodeForm;
